<template>
  <div>
    <Masthead :report_type="report.origin" :title="title"/>
    <C4Cover :report="report"/>
    <ScheduleA v-if="reportDisplay('scheduleA')" :report="report"/>
    <ScheduleB v-if="reportDisplay('scheduleB')" :report="report"/>
    <ScheduleC v-if="reportDisplay('scheduleC')" :report="report"/>
    <ScheduleL v-if="reportDisplay('scheduleL')" :report="report"/>
    <ReportAttachments v-if="reportDisplay('attachments')" :report="report"/>

  </div>
</template>

<script>
import Masthead from "./Masthead";
import C4Cover from "./C4Cover";
import ScheduleA from "./ScheduleA";
import ScheduleB from "./ScheduleB";
import ScheduleC from "./ScheduleC";
import ScheduleL from "./ScheduleL";
import filters from "../filters";
import utils from "./report-utils";
import ReportAttachments from "./ReportAttachments";

export default {
  name: "C4",
  data() {
    return {
      title: 'SUMMARY, FULL REPORT RECEIPTS AND EXPENDITURES'
    }
  },
  components: {ReportAttachments, ScheduleL, ScheduleC, ScheduleB, ScheduleA, C4Cover, Masthead},
  props: {
    report: {
      type: Object,
      default: function () {
        return {origin: "none"}
      }
    }
  },
  methods: {
    ...filters.filters, ...utils,

    reportDisplay(report) {
      let result = false;
      switch (report) {
        case 'scheduleA':
          if ((this.report.user_data.sums.expenses_under_50 && this.report.user_data.sums.expenses_under_50.amount !== 0)
              || this.arrayHasItems(this.report.user_data.expenses)
              || this.arrayHasItems(this.report.user_data.misc_receipts)
              || (this.report.user_data.sums.non_itemized_credit_expenses && this.report.user_data.sums.non_itemized_credit_expenses.amount !== 0)
              || (this.report.user_data.sums.non_itemized_cash_expenses && this.report.user_data.sums.non_itemized_cash_expenses.amount !== 0)) {
            result = true;
          }
          break;
        case 'scheduleB':
          if (this.arrayHasItems(this.report.user_data.contributions_inkind)
              || this.arrayHasItems(this.report.user_data.debt)
              || this.arrayHasItems(this.report.user_data.pledge)) {
            result = true;
          }
          break;
        case 'scheduleC':
          if (this.arrayHasItems(this.report.user_data.expense_corrections)
              || this.arrayHasItems(this.report.user_data.expense_refunds)
              || this.arrayHasItems(this.report.user_data.contribution_corrections)) {
            result = true;
          }
          break;
        case 'scheduleL':
          if (this.report.user_data.loan &&
              (this.arrayHasItems(this.report.user_data.loan.payments)
                  || this.arrayHasItems(this.report.user_data.loan.balances)
                  || this.arrayHasItems(this.report.user_data.loan.receipts))) {
            result = true;
          }
          break;
        case 'attachments':
          if (this.arrayHasItems(this.report.user_data.attachments)) {
            return true;
          }
          if (this.arrayHasItems(this.report.attachments)) {
            return true;
          }
          break;
      }
      return result;
    }
  }
}
</script>
